module.exports = __webpack_public_path__ + "img/image5.01686e8f.svg";